module.exports = __webpack_public_path__ + "static/media/vinnyikrym.2b943575.jpg";